//@flow

import React from "react"
import { EntityList } from "../UI/EntityList"
import { PrimaryButton } from "../UI/Buttons"
import { SearchField } from "../UI/Toolbar"
import { Flex } from "../UI/Page"
import Loader from "../UI/Loader"
import withSearchHandler from "./withSearchHandler"
import type { Props, SearchProps, SearchState } from "./types"

type SearchListProps = Props & SearchProps

class SearchListView extends React.Component<SearchListProps, SearchState> {
  searchInput: Object

  render() {
    const {
      entityName,
      children,
      handleNewClick,
      loading,
      handleSearchChange,
      changed,
      query
    } = this.props

    return (
      <Flex grow={1} direction={"column"}>
        {handleNewClick ? (
          <PrimaryButton onClick={handleNewClick}>New</PrimaryButton>
        ) : (
          ""
        )}
        <Flex grow={1} shrink={0}>
          <SearchField
            placeholder={`Search ${entityName}`}
            innerRef={input => (this.searchInput = input)}
            onChange={handleSearchChange}
            value={query}
          />
        </Flex>
        <Loader loading={loading || changed}>
          <EntityList>{children}</EntityList>
        </Loader>
      </Flex>
    )
  }
}

export default withSearchHandler(SearchListView)



// WEBPACK FOOTER //
// ./src/SearchTableView/SearchListView.js